<template>
    <div>
        <borrower-id v-if="position === 0"></borrower-id>
        <borrower-characteristics v-else-if="position === 1"></borrower-characteristics>
        <preferences v-else-if="position === 2"></preferences>
        <recommendations v-else></recommendations>
    </div>
</template>

<script>
    // @ is an alias to /src
    // import HelloWorld from '@/components/HelloWorld.vue'

    import { createNamespacedHelpers } from 'vuex'
    const { mapGetters } = createNamespacedHelpers('loans');
    import Recommendations from "../components/Recommendations";
    import BorrowerCharacteristics from "../components/BorrowerCharacteristics";
    import BorrowerId from "../components/BorrowerId";
    import Preferences from "../components/Preferences";
    export default {
        name: 'Home',
        components: {BorrowerId, BorrowerCharacteristics, Recommendations, Preferences},
        data() {
            return {
                maximum: 4
            }
        },
        computed: {
            ...mapGetters(['GET_POSITION']),
            position() {
                return this.GET_POSITION;
            }
        }
    }
</script>
<style scoped>

</style>
